'use strict';

var React = require('react');

var SvgReceiptPoundFilledIcon = function SvgReceiptPoundFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.142 16.934a1 1 0 0 1-.642-.934v-11a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v11a1 1 0 0 1-1.743.669l-1.502-1.669h-.01l-1.502 1.669a1 1 0 0 1-1.486 0l-1.502-1.669h-.01l-1.502 1.669a1 1 0 0 1-1.101.265Zm5.108-11.934a1.75 1.75 0 0 0-1.75 1.75v2h-.75a.75.75 0 0 0 0 1.5h.75v1.5h-.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-2.25v-1.5h.75a.75.75 0 0 0 0-1.5h-.75v-2a.25.25 0 0 1 .25-.25h.75v1a.75.75 0 0 0 1.5 0v-1.25c0-.69-.56-1.25-1.25-1.25h-1Z"
  }));
};
SvgReceiptPoundFilledIcon.displayName = "ReceiptPoundFilledIcon";

exports.SvgReceiptPoundFilledIcon = SvgReceiptPoundFilledIcon;
